import React from "react";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { Row, StackProps } from "@rui/Stack";

interface ChipProps extends StackProps {
  startIcon?: React.ReactNode;
}

const Container = styled(Row)({
  padding: "2px 4px",
  borderRadius: "4px",
  "&:hover": {
    cursor: "default",
  },
});

const Chip = ({ startIcon, children, ...props }: ChipProps) => (
  <Container variant="left" {...props}>
    {startIcon}
    <Typography variant="labelMed">{children}</Typography>
  </Container>
);

export default Chip;
